
/***
* Code added by AI Assistant
* Prompt:  wixLocation.to("https://www.lutelhotel.com/?tripla_booking_widget_open=search");
***/
import wixLocationFrontend from 'wix-location-frontend';

$w('#searchButton').onClick(() => {
    wixLocationFrontend.to("https://www.lutelhotel.com/?tripla_booking_widget_open=search");
});
